export interface EventDTO {
  id?: number;
  date: string,
  active: boolean,
  reason: string,
  repeatable: boolean,
  eventType: EventTypeEnum,
  messagePl: string,
  messageEn: string,
  bgColor: string,
  textColor: string
}

export enum EventTypeEnum {
  HOLIDAY = "HOLIDAY",
  AIRAC = "AIRAC",
  OTHER = "OTHER"
}